export default "__VITE_ASSET__CLBf$0Ua__"